import React, { useEffect } from "react";
import {
  ProjectBackgroundImageContainer,
  ProjectBannerBg,
  ProjectBannerImage,
} from "./style";
import { graphql, useStaticQuery } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import AOS from "aos";
import "aos/dist/aos.css";
const ProjectBanner = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    // AOS.refresh();
  }, []);
  const data = useStaticQuery(graphql`
    query {
      allProjectJson {
        edges {
          node {
            img {
              childImageSharp {
                fluid {
                  # ...GatsbyImageSharpFluid
                  ...GatsbyImageSharpFluid_withWebp
                }
                gatsbyImageData(
                  width: 200
                  placeholder: DOMINANT_COLOR
                  formats: NO_CHANGE
                )
              }
            }
          }
        }
      }
    }
  `);
  // console.log(data);
  const banner_image =
    data.allProjectJson.edges[0].node.img.childImageSharp.fluid;

  const image = getImage(data.allProjectJson.edges[0].node.img.gatsbyImageData);

  // Use like this:
  const bgImage = convertToBgImage(image);
  console.log(data);

  return (
    <ProjectBackgroundImageContainer>
      <ProjectBannerImage
        Tag="section"
        fluid={banner_image}
        {...bgImage}
        preserveStackingContext>
        <ProjectBannerBg>
          <GatsbyImage
            image={image}
            alt={"testimage"}
            style={{ filter: "brightness(50%)" }}
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom"
          />
        </ProjectBannerBg>
      </ProjectBannerImage>
    </ProjectBackgroundImageContainer>
  );
};

export default ProjectBanner;
